const actions = {
  SET_STATE: 'subscription/SET_STATE',
  LOAD_SUBSCRIPTION: 'subscription/LOAD_SUBSCRIPTION',

  SET_PRODUCTS_STATE: 'subscription/SET_PRODUCTS_STATE',
  LOAD_PRODUCTS: 'subscription/LOAD_PRODUCTS',

  SET_SHOPIFY_PRODUCTS_STATE: 'subscription/SET_SHOPIFY_PRODUCTS_STATE',
  LOAD_SHOPIFY_PRODUCTS: 'subscription/LOAD_SHOPIFY_PRODUCTS',

  SET_INVOICES_STATE: 'subscription/SET_INVOICES_STATE',
  LOAD_INVOICES: 'subscription/LOAD_INVOICES',
}

export default actions
